// @ts-ignore
import glib from '@dagrejs/graphlib';
let graphlib = glib;
if (!graphlib && typeof window !== "undefined") {
    graphlib = window.graphlib;
}
export default graphlib;
//# sourceMappingURL=graphlib.js.map